<template>
  <section class="details">
    <Header />
    <loading :active.sync="isLoading"
             :can-cancel="false"
             color="#E30713"
             :height = 145
             :width = 145
             :opacity = 1
             backgroundColor="#eeeeee"
             :z-index = 3
             :is-full-page="fullPage"
    ></loading>
    <div class="container">
      <div class="row">
        <div class="details__header">
          <div class="details__header-nav">
            <router-link to="/result" class="btn">
              <svg width="15" height="10"
                   viewBox="0 0 15 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.99412 5H14M4.82353 9L1 5L4.82353 1"
                      stroke="#E30713" stroke-width="2" stroke-miterlimit="22.9256"
                      stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
              Общий расчет
            </router-link>
            <div class="label">Расчет участка {{ + sectorId + 1 }}</div>
          </div>
          <div class="details__header-subNav">
            <div class="title">
              <button class="editName" @click="focusInput">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <g opacity="0.5">
                    <path d="M11.966 3.18897L2.47796 12.7083L7.30667 17.5529L16.7947
                             8.03363L11.966 3.18897Z" fill="#E30713"></path>
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M16.7537 8.06179L11.9614 3.25376L13.9382 1.27045C14.2976 0.909849
                             14.8368 0.909849 15.1363 1.27045L18.7304 4.87647C19.0899 5.23708
                             19.0899 5.77798 18.7304 6.07848L16.7537 8.06179Z"
                          fill="#E30713"></path>
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M7.28977 17.5576L1 19L2.43766 12.6895L7.28977 17.5576Z"
                          fill="#E30713"></path>
                    <path d="M11.966 3.18897L2.47796 12.7083L7.30667 17.5529L16.7947 8.03363L11.966
                             3.18897Z"
                          stroke="#ECECEC"
                          stroke-miterlimit="22.9256"
                          stroke-linecap="round" stroke-linejoin="round"></path>
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M16.7537 8.06179L11.9614 3.25376L13.9382 1.27045C14.2976 0.909849
                             14.8368 0.909849 15.1363 1.27045L18.7304 4.87647C19.0899 5.23708
                             19.0899 5.77798 18.7304 6.07848L16.7537 8.06179Z"
                          stroke="#ECECEC" stroke-miterlimit="22.9256" stroke-linecap="round"
                          stroke-linejoin="round"></path>
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M7.28977 17.5576L1 19L2.43766 12.6895L7.28977 17.5576Z"
                          stroke="#ECECEC" stroke-miterlimit="22.9256"
                          stroke-linecap="round" stroke-linejoin="round"></path>
                  </g>
                </svg>
              </button>
              <input type="text" ref="title__input"
                     @input="updateSectorName"
                     :readonly="!isEditable" :value="sectorFromState.sectorName">
            </div>
            <div class="buttons">
              <DeleteBtn v-if="sectors.length > 1"
                         @showDeleteConfirmation="showDeleteConfirmation"/>
              <button class="edit" @click="edit">
                <img src="@/assets/img/cog-white.svg" alt="cog">
                Редактировать участок
              </button>
            </div>
          </div>
        </div>
        <div class="common__pane details__pane">
          <div class="common__title">
            Параметры расчета
          </div>
          <div class="details__params">
            <div class="details__params-item">
              <div class="details__params-item--single">
                <div class="title">
                  Ветровой район
                </div>
                <div class="val">
                  {{location.zone}}
                </div>
              </div>
              <div class="details__params-item--single">
                <div class="title">
                  Нормативное значение<br>
                  давления ветра W0
                </div>
                <div class="val">
                  {{ location.pressure }} кПа
                </div>
              </div>
            </div>
            <div class="details__params-item">
              <div class="details__params-item--single">
                <div class="title">
                  Тип местности
                </div>
                <div class="val">
                  {{location.type}}
                </div>
              </div>
              <div class="details__params-item--single">
                <div class="title">
                  Коэффициент надежности<br>
                  по ветровой нагрузке
                </div>
                <div class="val">
                  {{location.coefficient}}
                </div>
              </div>
            </div>
            <div class="details__params-item">
              <div class="details__params-item--single">
                <div class="title">
                  k(ze)
                </div>
                <div class="val">
                  {{ sectorResultFromState.paramK }}
                </div>
              </div>
              <div class="details__params-item--single">
                <div class="title">
                  ζ(ze)
                </div>
                <div class="val">
                  {{ sectorResultFromState.paramE }}
                </div>
              </div>
              <div class="details__params-item--single">
                <div class="title">
                  Коэфициент кореляции V-
                </div>
                <div class="val">{{ sectorResultFromState.paramV }}</div>
              </div>
            </div>
            <div class="details__params-item">
              <div class="details__params-item--single">
                <div class="title">
                  Аэродинамические коэфициенты
                </div>
                <div class="val">пиковые</div>
              </div>
              <div class="details__params-item--single">
                <div class="title__list">угловая зона</div>
                <div class="val">{{ sectorResultFromState.paramAeroC }}</div>
                <div class="title__list">парапетная зона</div>
                <div class="val">{{ sectorResultFromState.paramAeroD }}</div>
                <div class="title__list">центральная зона</div>
                <div class="val">{{ sectorResultFromState.paramAeroE }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="common__pane print__pb">
          <div class="common__title">Параметры участка</div>
          <div class="details__sectorParams">
            <div class="details__sectorParams-item">
              <div class="details__sectorParams-item--single">
                <div class="title">Способ крепления</div>
                <div class="val"
                     v-if="sectorFromState.material.mounting === 'ballast'">
                  Балластная кровля
                </div>
                <div class="val"
                     v-else>
                  Механическая фиксация
                </div>
              </div>
              <div class="details__sectorParams-item--single">
                <div class="title">Основание кровли</div>
                <div class="val">
                  <span>{{ currentMaterial.name }}</span>
                  <span v-if="sectorFromState.base.hasOwnProperty('type')
                  && !sectorFromState.base.type.isCustom">
                    {{ currentMaterialType.name }}
                  </span>
                  <span v-if="currentMaterial.hasOwnProperty('size')">
                    {{ currentMaterial.size }}
                  </span>
                </div>
              </div>
              <div class="details__sectorParams-item--single"
                   v-if="sectorFromState.base.hasOwnProperty('type')">
                <div class="title">Шаг между гофрами профлиста</div>
                <div class="val">{{ sectorFromState.base.type.size }} мм</div>
              </div>
            </div>
            <div class="details__sectorParams-item">
              <div class="details__sectorParams-item--single">
                <div class="title">Высота участка (h)</div>
                <div class="val">{{sectorFromState.height}} м</div>
              </div>
              <div class="details__sectorParams-item--single">
                <div class="title">Ширина участка (l)</div>
                <div class="val">{{sectorFromState.sideL}} м</div>
              </div>
              <div class="details__sectorParams-item--single">
                <div class="title">Длина участка (b)</div>
                <div class="val">{{sectorFromState.sideB}} м</div>
              </div>
            </div>
          </div>
        </div>
        <div class="common__title-details break">
          Схема участка
        </div>
        <div class="common__pane">
          <button class="print" @click="print">
            <img src="@/assets/img/print.svg" alt="print">
          </button>
          <div class="details__figure">
            <Figure :defaultSvgParams="defaultSvgParams"
                    :sideB="sectorFromState.sideB"
                    :sideL="sectorFromState.sideL"
                    ref="figure"/>
          </div>
        </div>
        <disclaimer />
      </div>
    </div>
    <component
      :is="mountingMethod"
      :sectorFromState="sectorFromState">
    </component>
    <ResultNav :isDetails="true"/>
    <Addons :isInDetails="true"/>
    <Plugins />
    <Prefooter @savePdf="savePdf" :isInDetails="true" @loadingStart="loadingStart()"
               @loadingEnd="loadingEnd()"/>
    <Footer />
    <transition name="fading">
      <DeleteConfirmation v-if="isShowDeleteConfirmation"
                          @confirm="deleteSector"
                          @cancel="isShowDeleteConfirmation = !isShowDeleteConfirmation"/>
    </transition>
  </section>
</template>
<script>

import axios from 'axios';
import { saveAs } from 'file-saver';

import { mapState, mapMutations } from 'vuex';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { isSafari } from '@/utils/utils';
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import Figure from '@/components/Figure.vue';
import DetailsMechanicalFixation from '@/components/Details/DetailsMechanicalFixation.vue';
import DetailsBallastFixation from '@/components/Details/DetailsBallastFixation.vue';
import ResultNav from '@/components/Result/ResultNav.vue';
import Prefooter from '@/components/Prefooter.vue';
import Addons from '@/components/Addons.vue';
import Plugins from '@/components/Plugins.vue';
import DeleteBtn from '@/components/DeleteBtn.vue';
import DeleteConfirmation from '@/components/DeleteConfirmation.vue';
import Disclaimer from '@/components/Disclaimer.vue';

export default {
  data() {
    return {
      isEditable: false,
      isShowDeleteConfirmation: false,
      fullPage: true,
      isLoading: false,
    };
  },
  components: {
    Disclaimer,
    Header,
    Figure,
    DetailsMechanicalFixation,
    DetailsBallastFixation,
    ResultNav,
    Addons,
    Plugins,
    Prefooter,
    Footer,
    DeleteBtn,
    DeleteConfirmation,
    Loading,
  },
  methods: {
    ...mapMutations({
      UPDATE_SECTOR_STEP: 'UPDATE_SECTOR_STEP',
      UPDATE_SECTOR_PARAM: 'UPDATE_SECTOR_PARAM',
      DELETE_SECTOR: 'DELETE_SECTOR',
    }),
    showDeleteConfirmation() {
      this.isShowDeleteConfirmation = true;
    },
    print() {
      window.print();
    },
    focusInput() {
      this.isEditable = true;
      this.$refs.title__input.focus();
    },
    getMaterial(id) {
      return this.allMaterials[this.allMaterials.findIndex(p => p.id === id)];
    },
    updateSectorName(e) {
      this.UPDATE_SECTOR_PARAM({
        id: this.sectorId,
        param: 'sectorName',
        val: e.target.value,
      });
    },
    savePdf() {
      this.isLoading = true;
      const baseUrl = (process.env.NODE_ENV === 'development') ? process.env.VUE_APP_API_URL : `${window.location.origin}/`;
      const image = this.$refs.figure.$refs.figureCode.outerHTML;
      const string = new URLSearchParams();
      string.append('type', 'pdf_section');
      string.append('image', image);
      if (this.sectorFromState.material.mounting === 'ballast') {
        string.append('sectionType', 'ballast');
      } else {
        string.append('sectionType', 'mechanical');
      }
      const postData = {};
      const postDataHeader = {};
      const postDataSectorParams = {};
      const postDataFront = {};
      postDataFront.userInfo = this.userInfo;
      postDataFront.year = new Date().getFullYear();
      postDataHeader.zone = this.location.zone;
      postDataHeader.type = this.location.type;
      postDataHeader.pressure = this.location.pressure;
      postDataHeader.coefficient = this.location.coefficient;
      postDataHeader.paramK = this.sectorResultFromState.paramK;
      postDataHeader.paramE = this.sectorResultFromState.paramE;
      postDataHeader.paramV = this.sectorResultFromState.paramV;
      postDataHeader.paramAeroC = this.sectorResultFromState.paramAeroC;
      postDataHeader.paramAeroD = this.sectorResultFromState.paramAeroD;
      postDataHeader.paramAeroE = this.sectorResultFromState.paramAeroE;
      postDataHeader.sectorName = this.sectorFromState.sectorName;
      // console.log(this.sectorFromState.sectorName);
      if (this.sectorFromState.material.mounting === 'ballast') {
        postDataSectorParams.mounting = 'Баластная кровля';
      } else {
        postDataSectorParams.mounting = 'Механическая фиксация';
      }
      let materialType = '';
      // eslint-disable-next-line no-prototype-builtins
      if (this.sectorFromState.base.hasOwnProperty('type')
        && !this.sectorFromState.base.type.isCustom) {
        materialType = this.currentMaterialType.name;
      }
      let materialSize = '';
      // eslint-disable-next-line no-prototype-builtins
      if (this.currentMaterial.hasOwnProperty('size')) {
        materialSize = this.currentMaterial.size;
      }
      postDataSectorParams.base = `${this.currentMaterial.name} ${materialType} ${materialSize}`;
      // eslint-disable-next-line no-prototype-builtins
      if (this.sectorFromState.base.hasOwnProperty('type')) {
        postDataSectorParams.step = this.sectorFromState.base.type.size;
      }
      postDataSectorParams.height = this.sectorFromState.height;
      postDataSectorParams.sideB = this.sectorFromState.sideB;
      postDataSectorParams.sideL = this.sectorFromState.sideL;
      postData.header = postDataHeader;
      postData.sectorParams = postDataSectorParams;
      postData.sideInfo = this.sectorResultFromState.side;
      postData.firstPage = postDataFront;
      postData.albums = this.sectorResultFromState.albums;
      postData.material = `${this.getMaterial(this.sectorFromState.material.id).name} ${this.getMaterial(this.sectorFromState.material.id).thickness}`;
      if (this.sectorFromState.material.mounting === 'ballast') {
        postData.ballastVolumeTotalCount = this.sectorResultFromState.ballastVolumeTotalCount;
      } else {
        postData.fastenersTotalCount = this.sectorResultFromState.fastenersTotalCount;
      }
      if (this.sectorFromState.material.mounting === 'ballast') {
        if (this.sectorFromState.material.type === 'reinforced') {
          postData.ballastType = 'Армированная стяжка';
        } else {
          postData.ballastType = 'Гранитный щебень';
        }
      } else {
        postData.fastenersName = this.sectorResultFromState.fastenersElements;
      }
      // console.log(postData);
      string.append('data', JSON.stringify(postData));
      axios.post(`${baseUrl}service_api/pdf`, string, {
        responseType: 'blob', // Force to receive data in a Blob Format
      })
        .then((response) => {
          // console.log(response);
          // Create a Blob from the PDF Stream
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' },
          );
          // Build a URL from the file
          const fileURL = URL.createObjectURL(file);
          // Open the URL on new Window
          this.isLoading = false;
          if (this.isSafari) {
            const fileName = 'Детальный расчет по участку.pdf';
            saveAs(file, fileName);
          } else {
            window.open(fileURL);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    goToBase() {
    },
    edit() {
      this.$router.push(`/wizard/${this.sectorId}/`);
      this.UPDATE_SECTOR_STEP({
        id: this.sectorId,
        val: 'Base',
      });
    },
    deleteSector() {
      if ((this.sectors.length - 1) === parseInt(this.sectorId, 10)) {
        this.DELETE_SECTOR(this.sectorId);
        this.$router.push('/result');
        this.$root.onBodyScroll();
      } else {
        this.DELETE_SECTOR(this.sectorId);
        this.$root.onBodyScroll();
      }
    },
    loadingStart() {
      this.isLoading = true;
    },
    loadingEnd() {
      this.isLoading = false;
    },
  },
  watch: {
    isShowDeleteConfirmation() {
      // eslint-disable-next-line
      this.isShowDeleteConfirmation === true ? this.$root.offBodyScroll() :
        this.$root.onBodyScroll();
    },
  },
  mounted() {
    if (this.location.zone === '') {
      this.$router.push('/');
      console.clear();
    }
  },
  computed: {
    ...mapState({
      defaultSvgParams: state => state.defaultSvgParams,
      insulationMaterials: state => state.insulationMaterials,
      allMaterials: state => state.materials,
      location: state => state.location,
      sectors: state => state.sectors,
      userInfo: state => state.userInfo,
    }),
    isSafari() {
      return isSafari();
    },
    sectorId() {
      return (this.$route.params.id) ? this.$route.params.id : 0;
    },
    sectorFromState() {
      return this.$store.getters.getSector(this.sectorId);
    },
    sectorResultFromState() {
      return this.$store.getters.getSectorResult(this.sectorId);
    },
    currentMaterial() {
      return this.insulationMaterials[this.insulationMaterials.findIndex(p => p.id
        === this.sectorFromState.base.id)];
    },
    currentMaterialType() {
      return this.currentMaterial.types[this.currentMaterial.types.findIndex(p => p.id
      === this.sectorFromState.base.type.id)];
    },
    mountingMethod() {
      return this.sectorFromState.material.mounting === 'mechanical' ? 'DetailsMechanicalFixation' : 'DetailsBallastFixation';
    },
  },
};
</script>
<style lang="sass" scoped>
  .fading-enter-active, .fading-leave-active
    transition: opacity .5s
  .fading-enter, .fading-leave-to
    opacity: 0
  .print
    background: none
    border: none
    box-shadow: none
    outline: none
    cursor: pointer
    position: absolute
    top: 0
    right: 0
    +media((padding: (320: rem(17), 992: rem(27))))
  .details
    &__pane
      padding-bottom: rem(26)
      margin-bottom: rem(34)
    &__header
      width: 100%
      +media((padding: (320: rem(32) rem(24), 992: rem(34) 0 rem(39))))
      &-nav
        display: flex
        flex-direction: row
        align-items: center
        +media((padding-bottom: (320: rem(16), 992: rem(21))))
        .btn
          color: $red
          text-decoration: none
          box-shadow: none
          outline: none
          font-style: normal
          font-weight: 600
          font-size: rem(12)
          line-height: rem(24)
          border: rem(1) solid rgba(227, 7, 19, 0.5)
          box-sizing: border-box
          border-radius: rem(4)
          padding: 0 rem(19) 0 rem(13)
          transition: .5s
          margin-right: rem(4)
          height: rem(34)
          display: flex
          flex-direction: row
          align-items: center
          svg
            margin-right: rem(13)
            path
              transition: .5s
          &:hover
            background: $red-hover
            border-color: $red-hover
            color: #ffffff
            svg
              path
                stroke: #fff
        .label
          background: #F6F6F6
          border-radius: rem(4)
          min-width: rem(142)
          text-align: center
          padding: 0 rem(22)
          font-style: normal
          font-weight: 500
          font-size: rem(12)
          line-height: rem(24)
          height: rem(34)
          flex-direction: row
          align-items: center
          color: #5C5C5C
          +media((display: (320: none, 480: flex)))
      &-subNav
        display: flex
        justify-content: space-between
        +media((flex-direction: (320: column, 576: row)))
        +media((align-items: (320: flex-start, 576: center)))
        .title
          text-align: left
          display: flex
          flex-direction: row
          align-items: center
          +media((padding-bottom: (320: rem(16), 576: 0)))
          input
            +media((font-size: (320: rem(22), 992: rem(28))))
            +media((line-height: (320: rem(31), 992: rem(42))))
            font-style: normal
            font-weight: 500
            color: $black
            font-family: $main-font
            border: none
            background: transparent
            outline: none
            transition: .5s
            +media((max-width: (320: rem(230), 576: rem(240), 768: rem(350))))
            &:read-only
              pointer-events: none
            &:focus
              background: #FFFFFF
              border: rem(1) solid #ECECEC
              box-shadow: 0 rem(4) rem(12) rgba(0, 0, 0, 0.15)
              border-radius: rem(4)
        .delete__btn
          margin-right: rem(6)
        .edit
          background: $red
          border-radius: rem(4)
          transition: .5s
          color: #fff
          font-style: normal
          font-weight: bold
          font-size: rem(14)
          line-height: rem(17)
          text-decoration: none
          display: flex
          flex-direction: row
          align-items: center
          border: none
          outline: none
          box-shadow: none
          cursor: pointer
          // margin-left: rem(6)
          +media((padding: (320: rem(15) rem(12), 360: rem(15) rem(23) rem(15) rem(20),
          768: rem(15) rem(27) rem(15) rem(22))))
          img
            +media((margin-right: (320: rem(8), 360: rem(10), 992: rem(20))))
            transition: .5s
          &:hover
            background: $red-hover
            img
              transform: rotate(-180deg)
        .editName
          border-radius: rem(4)
          background: #ECECEC
          transition: .5s
          border: none
          display: flex
          flex-direction: row
          justify-content: center
          align-items: center
          cursor: pointer
          outline: none
          +media((margin-right: (320: rem(13), 960: rem(20))))
          +media((width: (320: rem(26), 960: rem(40))))
          +media((height: (320: rem(32), 960: rem(51))))
          g
            transition: .5s
          &:hover
            background: #fff
            g
              opacity: 1
        .buttons
          display: flex
          flex-direction: row
          align-items: center
    &__params, &__sectorParams
      display: grid
      text-align: left
      color: $black
      +media((grid-row-gap: (320: 0, 992: rem(44))))
      +media((grid-template-columns: (320: 1fr, 650: repeat(2, 1fr))))
      &-item
        &:nth-child(2n)
          +media((padding-left: (320: 0, 992: rem(40))))
        &--single
          display: grid
          +media((padding-bottom: (320: rem(19), 992: rem(24))))
          .title, .val
            font-style: normal
            font-weight: 500
            display: flex
            flex-direction: row
            align-items: center
            flex-wrap: wrap
            +media((font-size: (320: rem(13), 992: rem(14))))
            +media((line-height: (320: rem(19), 992: rem(20))))
          .val
            font-weight: bold
            span
              padding-right: rem(5)
    &__params
      &-item
        &:first-of-type, &:nth-child(2)
          position: relative
          &:after
            width: 100%
            height: rem(1)
            background: #ECECEC
            content: ""
            position: absolute
            +media((bottom: (320: rem(32), 992: rem(-12))))
            left: 0
        &:nth-child(2)
          +media((padding-bottom: (320: rem(45), 992: 0)))
        &:first-of-type
          &:after
            +media((display: (320: none, 650: block)))
        &--single
          +media((grid-template-columns: (320: 15fr 9fr, 992: 7fr 3fr)))
          .val
            +media((padding-left: (320: rem(13), 992: rem(20))))
          .title
            &__list
              font-weight: 500
              font-size: rem(12)
              line-height: rem(18)
              +media((padding-left: (320: rem(13), 992:  rem(20))))
              +media((padding-bottom: (320: rem(16), 992: rem(4))))
    &__sectorParams
      &-item
        &--single
          +media((grid-template-columns: (320: 5fr 4fr, 360: 1fr 1fr)))
          &:last-of-type
            padding-bottom: rem(10)
        &:first-of-type
          .val
            +media((padding-right: (650: rem(20), 800: 0)))
</style>
